import styled, { css } from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';
import { AngleBackIcon } from '@/components/UI/Icons/Icons';
import { Button } from '@/components/UI/Button/Button';
import { Modal as ModalComponent } from '@/components/UI/Modal';

export const Modal = styled(ModalComponent)`
  max-height: 95vh;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 50px;
  overflow-y: auto;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  gap: 10px;
  padding: 40px 50px 20px;
`;

export const ModalFooter = styled.div`
  width: 100%;
  padding: 0 50px 30px;
`;

export const ModalTitle = styled(Typography.Title).attrs({ $variant: '4' })<{
  $isCentered?: boolean;
}>`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
  ${({ $isCentered }) =>
    $isCentered &&
    css`
      justify-content: center;
    `}
`;

export const GoBackButton = styled(Button)`
  position: absolute;
`;

export const GoBackIcon = styled(AngleBackIcon)`
  width: 12px;
  height: 20px;

  path {
    fill: ${({ theme }) => theme.palette.secondary.labels};
  }
`;
